var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { attrs: { elevation: "0" } },
    [
      _c("configs-popup-edit-info", { ref: "configs-popup-edit-info" }),
      _c("c-edit-value-dialog", { ref: "c-edit-value-dialog" }),
      _c(
        "v-card",
        { attrs: { elevation: "0" } },
        [
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-2" },
            [
              _c(
                "v-btn",
                {
                  staticClass: "white--text",
                  attrs: { color: "green", small: "" },
                  on: { click: _vm.onCreate },
                },
                [
                  _c("v-icon", { attrs: { left: "", small: "" } }, [
                    _vm._v("mdi-plus"),
                  ]),
                  _vm._v(" Create Shared Config "),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "ma-0 pa-0 mx-2" },
            [
              _c(
                "v-card",
                {
                  staticClass: "ma-0 pa-0 scroll",
                  attrs: { width: "100%", elevation: "0" },
                },
                [
                  _c("c-shared-configs-table", {
                    on: {
                      "show-edit-info-popup": _vm.showEditInfoPopup,
                      "show-edit-group-popup": _vm.showEditGroupPopup,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }